import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--right",
  "use": "icon-arrow--right-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-arrow--right\"><path d=\"m14.923 9-5.924 5.923-.596-.596 4.905-4.906H3.076v-.843h10.232L8.403 3.673 9 3.077 14.923 9Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol